
import CbFormImage from "@/components/layouts/content-blocks/forms/CbFormImage.vue";
import {PageDetailModeEnum} from "@/models/enum/PageDetailModeEnum";

export default {
  computed: {
    PageDetailModeEnum() {
      return PageDetailModeEnum
    }
  },
  components: {CbFormImage}
}
